import React, { useState } from "react";
import "./tour-frame.styles.scss";
import PropertyInfo from "../property-info/property-info.component";

const TourFrame = ({ view }) => {
  const [info, setInfo] = useState(false);
  return (
    <div className="tour-frame">
      <iframe
        title="tour-frame"
        className="tour-frame-cupix"
        frameBorder="0"
        src={view}
      ></iframe>
      <button
        className="information-button"
        onClick={() => setInfo(!info)}
      ></button>
      {info ? <PropertyInfo handleToggle={setInfo} /> : null}
    </div>
  );
};

export default TourFrame;
